import DarkMode from "./modules/DarkMode";
import MainMenu from "./modules/MainMenu";
import BlockLink from "./modules/BlockLink";

document.addEventListener( 'DOMContentLoaded', () => {
    // parse translations as json
    // ctheme.translations = JSON.parse(ctheme.translations);

    document.querySelector('html').classList.remove('no-js');

    new DarkMode();
    new MainMenu();
    new BlockLink();
});